import { normalizeMessages } from '@/features/chat/messageNormalize'

function sameMessage(a, b) {
  if (!a || !b) return false
  return a.role === b.role && String(a.text ?? '') === String(b.text ?? '')
}

/**
 * True when the server holds every local message, in order, plus more at the end.
 *
 * Turn-based comparison cannot see these. A scheduled run appends an assistant
 * message with no user message before it, so it joins no turn and leaves the
 * turn count unchanged — `shouldReplaceWithServerMessages` would fetch the
 * message and then discard it as "nothing new".
 */
export function serverHasAppendedMessages(localMessages = [], serverMessages = []) {
  const local = normalizeMessages(localMessages)
  const server = normalizeMessages(serverMessages)
  if (server.length <= local.length) return false
  return local.every((message, index) => sameMessage(message, server[index]))
}
